import React from 'react';
import { buildEditorStateFromContent } from './editorStateUtils';

/**
 * Editor state that follows the text/styles props. Used by the read-only
 * Display so juror cards re-render whenever the saved notes change.
 *
 * The editable RichTextEditor must NOT use this: it owns its state and
 * receives external changes through its imperative handle so the user's
 * cursor survives remote updates.
 */
export default (richTextStyles, text, hasEllipsis = false) => {
  // Key on content so prop identity churn (fresh arrays from live
  // queries) doesn't rebuild the state needlessly.
  const stylesKey = JSON.stringify(richTextStyles || []);

  const [editorState, setEditorState] = React.useState(() =>
    buildEditorStateFromContent(text, richTextStyles, hasEllipsis),
  );

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    setEditorState(
      buildEditorStateFromContent(text, JSON.parse(stylesKey), hasEllipsis),
    );
  }, [text, stylesKey, hasEllipsis]);

  return [editorState, setEditorState];
};
